import React from "react";
import "./index.m.css";

export const CheckIcon = ({ color = "#C78D3C" }) => (
  <div styleName="checkIcon" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="17" 
      height="13" 
      viewBox="0 0 17 13" 
      fill="none"
      aria-hidden="true"
    >
      <path d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z" fill={color}/>
    </svg>
  </div>
);
